<template>
  <div class="p-contentplans-writing-user" ref="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  computed: {
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    }
  },
  methods: {
    scroll(el) {
      if (!el) {
        return;
      }
      this.$nextTick(() => {
        const elRect = el.getBoundingClientRect();
        const top = elRect.top - this.notificationsHeight - 24;
        window.scrollBy({ top, behavior: 'smooth' });
      });
    },
    scrollToTop() {
      if (!this.$refs.container) {
        return;
      }
      this.$nextTick(() => {
        const elRect = this.$refs.container.getBoundingClientRect();
        const top = elRect.top - this.notificationsHeight;
        window.scrollBy({ top, behavior: 'smooth' });
      });
    }
  }
};
</script>
